import { isUndefined } from 'lodash';
import { PositionDto, PrivateQuoteDto } from 'src/dtos';
import { Position } from 'src/models';

const enrichNonTradablePosition = (model: Position, privateQuote: PrivateQuoteDto): Position => {
  let result: Position = {
    ...model,
    isTradable: false,
    value: privateQuote.currentPrice,
    totalValue: model.quantity * privateQuote.currentPrice,
  };

  if (result.purchasePrice === 0) {
    result.purchasePrice = privateQuote.purchasePrice;
  }

  if (!isUndefined(privateQuote.lastPrice)) {
    result.value = privateQuote.lastPrice;
    result.totalValue = model.quantity * privateQuote.lastPrice;
  }

  return result;
};

const makeNonTradablePositionIfFound = (model: Position, privateQuotes: PrivateQuoteDto[]): Position => {
  const privateQuote = privateQuotes.find(aPrivateQuote => aPrivateQuote.symbol === model.symbol);

  if (!privateQuote) {
    return model;
  }
  let result = enrichNonTradablePosition(model, privateQuote);

  return result;
};

const mapPositionDtoToModel = (dto: PositionDto, privateQuotes: PrivateQuoteDto[]): Position => {
  let result: Position = {
    id: dto.OrderId.toString(),
    symbol: dto.Symbol,
    description: dto.Description,
    quantity: dto.OpenQuantity,
    purchasePrice: dto.OpenPrice,
    isTradable: true,
    totalCost: dto.CostBasis,
    date: dto.DateOpened,
  };

  result = makeNonTradablePositionIfFound(result, privateQuotes);

  return result;
};

export const mapPositionListDtoToModel = (dtos: PositionDto[], privateQuotes: PrivateQuoteDto[]): Position[] =>
  dtos.map(dto => mapPositionDtoToModel(dto, privateQuotes));
